import React from 'react';
import FormattedMessage from '@/intl/formatted-message';
import shopMessages from '../../intl/messages/shop';

export default function ShopDeliveryInfo({ takeawayServiceProps, prefixed = false }) {
  if (!takeawayServiceProps) {
    return null;
  }

  const divider = ' | ';
  const { sendTime, shipmentFee } = takeawayServiceProps;
  const sendTextShipmentFee = takeawayServiceProps && typeof shipmentFee === 'number'
    ? [divider, <FormattedMessage key="shipmentFee" {...shopMessages.deliveryFee} values={{ shipmentFee, currency: sessionStorage.getItem('currency') }} />]
    : '';
  const sendTextSendTime = takeawayServiceProps && typeof sendTime === 'number'
    ? [divider, <FormattedMessage key="sendTime" {...shopMessages.deliveryTime} values={{ sendTime }} />]
    : '';

  return (
    <span>
      {prefixed ? divider : ''}
      <FormattedMessage key="deliveryFlag" {...shopMessages.deliveryFlag} />
      {sendTextShipmentFee}
      {sendTextSendTime}
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/component/dish-menu/shop-deliverty-info.jsx